import styled, { css } from 'styled-components'

export const Avatar = styled.img`
  width: 32px;
  height: 32px;
  max-width: 32px;
  max-height: 32px;
  object-fit: cover;
  margin-bottom: 4px;
  background-color: var(--p-neutral-300);
  border-radius: 50%;

  ${({ $size }) =>
    $size === 'large' &&
    css`
      width: 160px;
      max-width: 160px;
      max-height: 160px;
      height: 160px;
    `}

  &:not(:last-child) {
    margin-right: 4px;
  }
`
